import { render, staticRenderFns } from "./TaskPopover.vue?vue&type=template&id=a63ede58&"
import script from "./TaskPopover.vue?vue&type=script&lang=ts&"
export * from "./TaskPopover.vue?vue&type=script&lang=ts&"
import style0 from "./TaskPopover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports